import React from "react";

const ThirdPartyCookies = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-4">Third Party Cookies and other tracking technology</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-300 mb-8">
          <thead>
            <tr>
              <th className="border border-gray-300 px-8 py-2 text-left">Service</th>
              <th className="border border-gray-300 px-8 py-2 text-left">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-8 py-2 text-left">Firebase Authentication</td>
              <td className="border border-gray-300 px-8 py-2 text-left">Firebase Authentication allows us to authenticate users to the Vtranslate app. Every time a user signs in, the user credentials are sent to the Firebase Authentication backend and exchanged for a Firebase ID token (a JWT) and refresh token. Firebase ID tokens are short lived and last for an hour; the refresh token can be used to retrieve new ID tokens.</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-8 py-2 text-left">Firebase Cloud Firestore</td>
              <td className="border border-gray-300 px-8 py-2 text-left">Crash Reporting creates detailed reports of the errors in the Vtranslate app. We use the platform to track app crashes as they occur and prevent future ones. Errors are grouped into issues based on having similar stack traces and triaged by the severity of impact on users. We do not collect any personally identifiable information (such as names, email addresses, or phone numbers) with Crash Reporting.</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-8 py-2 text-left">Firebase A/B Testing (Remote Config)</td>
              <td className="border border-gray-300 px-8 py-2 text-left">Firebase Remote Config is an A/B testing and configuration service provided by Google Inc. Personal Data collected: various types of Data as specified in the privacy policy of the service.</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-8 py-2 text-left">OpenAI</td>
              <td className="border border-gray-300 px-8 py-2 text-left">VTranslate uses OpenAI's API to provide AI-powered translation style suggestions, text refinement, dictionary lookups, and word suggestions. Text content you enter is sent to OpenAI's servers for processing. OpenAI does not use API data for training models.</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-8 py-2 text-left">Soniox</td>
              <td className="border border-gray-300 px-8 py-2 text-left">VTranslate uses Soniox for real-time speech-to-text transcription and translation. Audio from your microphone is streamed to Soniox servers during active voice sessions only. Audio is processed in real-time and is not permanently stored.</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-8 py-2 text-left">Google Cloud Vision</td>
              <td className="border border-gray-300 px-8 py-2 text-left">VTranslate uses Google Cloud Vision API to extract text from images captured by your camera for translation purposes.</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-8 py-2 text-left">Google Cloud Translate</td>
              <td className="border border-gray-300 px-8 py-2 text-left">VTranslate uses Google Cloud Translation API to translate text between languages.</td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-8 py-2 text-left">Google Cloud TTS / Microsoft Azure TTS</td>
              <td className="border border-gray-300 px-8 py-2 text-left">VTranslate uses text-to-speech services to read translations aloud. Text is sent to these services to generate audio.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ThirdPartyCookies;